export default __webpack_public_path__ + "static/media/platelets.a50fc2dd.svg";